import React from 'react';
import { HashRouter } from 'react-router-dom';
import SideNav from '../../components/SideNav';
import classNames from 'classnames';
import AppRoute from '../routes/AppRoute';
import { useSelector } from 'react-redux';
import ToolBar from '../../components/ToolBar';
import { loginSelector } from '../../features/loginSlice';
import { dashboardSelector } from '../../features/dashboardSlice';
import '../../assets/style/Layout.css';

const Layout = () => {
  const loginStore = useSelector(loginSelector);
  const dashboardState = useSelector(dashboardSelector);
  return (
    <HashRouter>
      <div className="layout">
        {loginStore.status === 'authenticated' ? (
          <>
            <SideNav />
            <div
              className={classNames('content', {
                'is-open': dashboardState.isOpenSideMenu,
              })}
            >
              <ToolBar />
              <AppRoute />
            </div>
          </>
        ) : (
          <AppRoute />
        )}
      </div>
    </HashRouter>
  );
};

export default Layout;
